import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
export type ArtistPreviewTab = "active" | "winners";
export function useArtistPreviewModal() {
  const $ = _c(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState("active");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = tab => {
      setModalInitialTab(tab);
      setIsModalOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleBadgeClick = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpen(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleModalClose = t1;
  let t2;
  if ($[2] !== isModalOpen || $[3] !== modalInitialTab) {
    t2 = {
      isModalOpen,
      modalInitialTab,
      handleBadgeClick,
      handleModalClose
    };
    $[2] = isModalOpen;
    $[3] = modalInitialTab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}